import { Button, Checkbox } from '@goodlok/react-sdk'
import { Input, notify } from '@goodlok/ui'
import { useMutation } from '@tanstack/react-query'
import { FunctionComponent, useState } from 'react'
import { useAdminPageData } from '../utilities/useAdminPageData'
import { adminZeus } from './Layout'
import styles from './ShiftSettings.module.sass'

type ShiftSettingsProps = {
	item: NonNullable<
		NonNullable<
			NonNullable<ReturnType<typeof useAdminPageData>['data']>['getVenue']
		>['timetableDays'][number]['shiftGroups'][number]['queue']
	>['items'][number]
	updateData: () => Promise<void>
	onSubmit: () => void
}

export const ShiftSettings: FunctionComponent<ShiftSettingsProps> = ({
	item,
	updateData,
	onSubmit,
}) => {
	const [startTime, setStartTime] = useState(item.start)
	const [endTime, setEndTime] = useState(item.end)

	const [isOvertime, setIsOvertime] = useState(item.shift?.isOvertime ?? false)

	const updateShiftMutation = useMutation(
		['updateShift'] as const,
		async () => {
			const { updateEmployeeQueueItem } = await adminZeus('mutation')({
				updateEmployeeQueueItem: [
					{
						by: { id: item.id },
						data: {
							start: startTime,
							end: endTime,
							shift: {
								update: {
									isOvertime: isOvertime,
								},
							},
						},
					},
					{ ok: true, errorMessage: true },
				],
			})
			return updateEmployeeQueueItem
		},
		{
			onSuccess: (data) => {
				if (!data.ok) {
					console.error(data.errorMessage)
					notify('Nepodařilo se uložit směnu', 'error')
					return
				}
				notify('Směna uložena', 'success')
				updateData()
				onSubmit()
			},
		}
	)

	return (
		<div className={styles.wrapper}>
			<div className={styles.times}>
				<div className={styles.timeSelector}>
					<Input
						type="time"
						value={startTime}
						max={endTime}
						size="compact"
						onChange={(event) => {
							setStartTime(event.target.value)
						}}
						label="Od"
					/>
				</div>
				<div className={styles.timeSelector}>
					<Input
						type="time"
						value={endTime}
						min={startTime}
						size="compact"
						onChange={(event) => {
							setEndTime(event.target.value)
						}}
						label="Do"
					/>
				</div>
			</div>
			<Checkbox
				label="Označit směnu jako přesčas"
				checked={isOvertime}
				onChange={(checked) => {
					setIsOvertime(checked)
				}}
			/>

			<div className={styles.button}>
				<Button
					type="button"
					variant="primary"
					disabled={
						startTime === item.start &&
						endTime === item.end &&
						isOvertime === item.shift?.isOvertime
					}
					onClick={() => {
						updateShiftMutation.mutate()
					}}>
					ok
				</Button>
			</div>
		</div>
	)
}
